const variables = {
  headlineTagStyle: 'displayMedium',
};

export default variables;
